import intersection from 'lodash/intersection';

/**
 * @name parseEqualsLogic
 * @description Little helper that checks for equality of two values, either
 * of which could be an array, so we're parsing both as arrays and comparing
 * a string representation
 */
export const parseEqualsLogic = (
  selection: string | string[],
  values: string | string[]
) => {
  const a = Array.isArray(selection) ? selection : [selection];
  const b = Array.isArray(values) ? values : [values];
  const isDifferent = a.sort().join(',') !== b.sort().join(',');

  return isDifferent;
};

/**
 * @name parseHasNoContent
 * @description Returns false if skip condition has no content (reverse logic)
 */
export const parseHasNoContent = (value: any) => {
  const notExists = typeof value === 'undefined' || value === '';

  return !notExists;
};

/**
 * @name parseHasContent
 * @description Returns false if skip condition has content (reverse logic)
 */
export const parseHasContent = (value: any) => {
  const exists = typeof value !== 'undefined' && value !== '';

  return !exists;
};

/**
 * @name parseHasNotLogic
 * @description Little helper that checks for equality of two values, either
 * of which could be an array, so we're parsing both as arrays. From there, we
 * use lodash to see if there is any "overlap" which would break the
 * "hasNot" logic
 */
export const parseHasNotLogic = (
  selection: string | string[],
  values: string | string[]
) => {
  const a = Array.isArray(selection) ? selection : [selection];
  const b = Array.isArray(values) ? values : [values];
  const intersect = intersection(a, b);
  const isDifferent = intersect.length !== 0;

  return isDifferent;
};
